module.exports = __webpack_public_path__ + "static/media/subreservation_detail.6343d7ea.jpg";